import { createAsyncThunk } from "@reduxjs/toolkit";

export const createAsyncThunkWithTraceID = <ReturnType, ThunkArg = void>(
  thunkName: string,
  func: (data: ThunkArg) => ReturnType | Promise<ReturnType>,
) => {
  return createAsyncThunk<ReturnType, ThunkArg, { rejectValue: { traceID?: string } }>(
    thunkName,
    async (data, { rejectWithValue }) => {
      try {
        return await func(data);
      } catch (error) {
        const traceID = (error as { traceID?: string } | null | undefined)?.traceID;
        return rejectWithValue({ traceID });
      }
    },
  );
};
